import AbstractElement from "../../pages/AbstractElement";
import TabNav from "./TabNav";

class CarouselTab extends AbstractElement {

    private activeID: number;
    private tabNav: TabNav;
    private $carouselElement: JQuery;
    private carousel: any;

    constructor(template: JQuery) {
        super(template);
    }

    init(): void {
        super.init();
        this.activeID = 0;
        this.initTabNav();
    }

    private initTabNav(): void {
        this.tabNav = new TabNav(this.template.find('> .tab__nav'));
        this.tabNav.emitter.on('TAB_NAV_CLICK', (data) => {
            this.activeID = data.id;
            this.changeCarousel(this.activeID);
            this.emitter.emit('CHANGE_BG_COLOR', {bgColor: data.bgColor});
        });
    }

    public initCarousel(options: any = {}): void {
        this.$carouselElement = this.template.find('> .tab__content > .owl-carousel');
        this.carousel = this.$carouselElement.owlCarousel(options);
        this.carousel.on('to.owl.carousel', (e: JQuery.Event) => e.stopPropagation());
        this.carousel.on('translated.owl.carousel', (e: any) => {
            e.stopPropagation();
            this.carousel.trigger('refresh.owl.carousel');
            this.emitter.emit('CAROUSEL_CHANGED');
        });
        this.carousel.on('changed.owl.carousel', (e: any) => {
            e.stopPropagation();
            this.activeID = e.item.index;
            this.tabNav.activeLink(this.activeID);
            this.tabNav.scrollNav(this.activeID);
        });
        this.carousel.on('refreshed.owl.carousel', (e: JQuery.Event) => {
            e.stopPropagation();
            this.emitter.emit('CAROUSEL_REFRESHED');
        });
    }

    public refreshCarousel(): void {
        this.carousel.trigger('refresh.owl.carousel');
    }

    public changeCarousel(id: number): void {
        this.carousel.trigger('to.owl.carousel', [id, 500]);
    }
}

export default CarouselTab;